export default function CurrentIssues() {
  const issues = [
    {
      icon: 'ri-flask-line',
      title: '납 성분 결함 문제',
      description:
        '기존 유통되는 가정용 수도계량기에서 기준치 이상의 납 성분이 검출되는 심각한 결함 문제가 발생하고 있습니다.',
      color: 'red',
    },
    {
      icon: 'ri-time-line',
      title: '장기 사용 주기 문제',
      description:
        '온도계, 난방계량기, 가스계량기 등 모든 계량기에서 의도적으로 장기 사용을 요구하여 개혁이 이루어지지 않는 현실입니다.',
      color: 'orange',
    },
    {
      icon: 'ri-government-line',
      title: '규제 기준 부재',
      description:
        '미국은 수도계량기의 납 잔존량을 0.25% 이하로 제한하고 있으나, 한국을 비롯한 일부 국가는 납 성분 잔존 불순물에 대한 명확한 제한이 없습니다.',
      color: 'yellow',
    },
  ];

  const colorClasses = {
    red: {
      bg: 'bg-red-600',
      light: 'bg-red-50',
      text: 'text-red-600',
      border: 'border-red-200',
    },
    orange: {
      bg: 'bg-orange-600',
      light: 'bg-orange-50',
      text: 'text-orange-600',
      border: 'border-orange-200',
    },
    yellow: {
      bg: 'bg-yellow-600',
      light: 'bg-yellow-50',
      text: 'text-yellow-600',
      border: 'border-yellow-200',
    },
  };

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block px-5 py-2 bg-teal-50 border border-teal-200 rounded-full mb-4">
            <span className="text-teal-600 text-xs md:text-sm font-bold uppercase tracking-wider">Current Issues</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6">
            현 사회적 문제
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto mb-5 md:mb-7"></div>
          <p className="text-sm md:text-lg text-gray-600 max-w-3xl mx-auto font-medium">
            수도미터기 시장의 현재 문제점과 개선이 필요한 사항들
          </p>
        </div>

        {/* 문제점 카드 */}
        <div className="grid md:grid-cols-3 gap-5 md:gap-8 mb-10 md:mb-16">
          {issues.map((issue, index) => {
            const classes = colorClasses[issue.color as keyof typeof colorClasses];
            if (!classes) {
              console.warn(`Unsupported color "${issue.color}" for issue at index ${index}`);
              return null;
            }
            return (
              <div
                key={index}
                className={`bg-white border-2 ${classes.border} rounded-2xl p-6 md:p-9 hover:shadow-xl transition-all duration-300 hover:-translate-y-1`}
              >
                <div
                  className={`w-14 md:w-18 h-14 md:h-18 ${classes.bg} rounded-xl flex items-center justify-center mb-5 md:mb-7`}
                >
                  <i className={`${issue.icon} text-3xl md:text-4xl text-white`}></i>
                </div>
                <h3 className={`text-xl md:text-2xl font-black ${classes.text} mb-4 md:mb-5`}>
                  {issue.title}
                </h3>
                <p className="text-base md:text-lg text-gray-700 leading-relaxed font-medium">
                  {issue.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* 당사의 솔루션 */}
        <div className="bg-gradient-to-br from-teal-600 to-[#0a3d4f] rounded-2xl shadow-2xl p-6 md:p-9 lg:p-13 text-white">
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-9">
            <div className="w-16 md:w-22 h-16 md:h-22 bg-white rounded-2xl flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-check-line text-4xl md:text-6xl text-teal-600"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-xl md:text-3xl lg:text-4xl font-black mb-4 md:mb-5">
                당사는 수도계량기 사업 분야에서 일본, 독일보다 더 경쟁력 있는 가격으로 스테인리스
                재질 및 친환경 플라스틱 재질을 이용하여 스마트 수도미터기를 제작합니다
              </h3>
              <p className="text-base md:text-xl text-teal-100 leading-relaxed mb-5 font-medium">
                당사는 의료 분야 사양에 대해서 일본보다 더 경쟁력 있는 가격으로{' '}
                <strong className="text-white">스테인리스 재질</strong>을 이용하여 스마트 수도미터기를
                제작합니다.
              </p>
              <div className="flex flex-wrap gap-3 md:gap-5 justify-center md:justify-start">
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 md:px-5 py-2 md:py-3">
                  <span className="font-bold text-sm md:text-lg whitespace-nowrap">
                    ✓ 납 성분 제로
                  </span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 md:px-5 py-2 md:py-3">
                  <span className="font-bold text-sm md:text-lg whitespace-nowrap">
                    ✓ 스테인리스 재질
                  </span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 md:px-5 py-2 md:py-3">
                  <span className="font-bold text-sm md:text-lg whitespace-nowrap">
                    ✓ 경쟁력 있는 가격
                  </span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 md:px-5 py-2 md:py-3">
                  <span className="font-bold text-sm md:text-lg whitespace-nowrap">
                    ✓ 의료 분야 사양
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
